import { render, staticRenderFns } from "./LoteCertificado.vue?vue&type=template&id=6688a0b5"
import script from "./LoteCertificado.vue?vue&type=script&lang=js"
export * from "./LoteCertificado.vue?vue&type=script&lang=js"
import style0 from "./LoteCertificado.vue?vue&type=style&index=0&id=6688a0b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports